/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetEventMarker {
  size?: number,
  arrowColor?: string,
  fillColor?: string,
  opacity?: number
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for moving events of the asset
 *
 * ```typescript
 *  import {getAssetEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetEventMarker({size, outlineColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : angle - 90 // base icon is already pointing at 90, need to rotate back
 * }
 * ```
 */
export const getAssetEventMarker = ({
  fillColor = dlsColor('grey4'),
  arrowColor = dlsColor('white'),
  size = 24,
  opacity = 1
}: AssetEventMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='${arrowColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9938 17.5203 17.5203 21.9938 12 22V22Z' fill='${fillColor}' opacity='${opacity}' stroke='white'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 4L7 18L12 14.6667L17 18L12 4Z' fill='${arrowColor}'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetEventMarker;
